export interface Teacher {
  id: string;
  name: string;
  link: string;
}

export enum EventStatus {
  UPCOMING = 'upcoming',
  LIVING = 'living',
  ENDED = 'ended',
}

export interface Event {
  id: number;
  title: string;
  image: string;
  date: string;
  time: string;
  platform: string;
  status: EventStatus;
  price: 'free' | 'paid';
  link: string;
  teachers: Teacher[];
}

export interface EventFilter {
  status?: EventStatus | 'ALL';
}
